var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
export default (function (_a) {
    var className = _a.className, htmlAttributes = __rest(_a, ["className"]);
    return (React.createElement("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", className: className }, htmlAttributes),
        React.createElement("path", { d: "M0 0h24v24H0z", style: { fill: 'none' } }),
        React.createElement("path", { d: "M-883 241a10.011 10.011 0 01-10-10 10.011 10.011 0 0110-10 10.011 10.011 0 0110 10 10.011 10.011 0 01-10 10zm0-8.6l2.805 2.806a.986.986 0 00.7.291.985.985 0 00.7-.291.994.994 0 000-1.4L-881.6 231l2.806-2.807a.985.985 0 00.29-.7.985.985 0 00-.29-.7.986.986 0 00-.7-.291.984.984 0 00-.7.291L-883 229.6l-2.807-2.806a.984.984 0 00-.7-.291.986.986 0 00-.7.291.993.993 0 000 1.4L-884.4 231l-2.807 2.806a.994.994 0 000 1.4.988.988 0 00.7.29.985.985 0 00.7-.29L-883 232.4z", transform: "translate(895 -219)" })));
});
